var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardMyPurchasedBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1475 16.6335C3.30983 12.7217 2.88983 10.7652 3.941 9.46666C4.991 8.16699 6.99183 8.16699 10.9923 8.16699H17.0077C21.0093 8.16699 23.0078 8.16699 24.059 9.46666C25.109 10.7663 24.6902 12.7217 23.8525 16.6335L23.352 18.9668C22.7838 21.6187 22.5003 22.944 21.5378 23.7222C20.5753 24.5003 19.2197 24.5003 16.5083 24.5003H11.4917C8.78033 24.5003 7.42466 24.5003 6.46333 23.7222C5.49966 22.944 5.215 21.6187 4.648 18.9668L4.1475 16.6335Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.33331 14H18.6666M11.6666 17.5H16.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M21 10.5L17.5 3.5M7 10.5L10.5 3.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMyPurchasedBookingIcon);
export default __webpack_public_path__ + "static/media/dashboard_my_purchased_booking_icon.7da429bae6ebf4d925c6cc4c36a0d380.svg";
export { ForwardRef as ReactComponent };